export enum InputType {
    CUSTOMER_ID = 'customerId',
    LIST_ID = 'listId',
    USER_ID = 'userId'
}
